import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import classnames from 'classnames';
import { Upload, Icon, Row, Spin } from 'grab-ui';
import uploadIcon from 'public/images/upload-round.svg';
import css from './spreadsheet-uploader.less';

const Dragger = Upload.Dragger;
const loadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class SpreadSheetUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  beforeUpload = file => {
    const { handleExcelUpload } = this.props;

    handleExcelUpload(file);
    return false;
  };

  render() {
    const { loading, hoverOnModal, handleCancelEvent } = this.props;
    return (
      <Dragger
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        beforeUpload={this.beforeUpload}
        showUploadList={false}
        className={css.dragger}
      >
        {!loading ? (
          <div
            className={classnames(
              { [css.maskBackGround]: hoverOnModal },
              css.contentModal,
            )}
            onClick={handleCancelEvent}
            role="button"
            tabIndex={-123}
            onKeyPress={null}
          >
            <Row className={css.subInfo}>
              <img
                src={uploadIcon}
                className={css.fixedSize}
                alt=" Grab Upload Icon"
              />
              <p>{I18n.t('v2.homepage.uploadOrder.modal.exploreXLS')}</p>
              <p className={css.lightText}>
                {I18n.t('v2.homepage.uploadOrder.modal.dragFile')}
              </p>
            </Row>
          </div>
        ) : (
          <Spin indicator={loadingIcon} />
        )}
      </Dragger>
    );
  }
}

SpreadSheetUploader.propTypes = {
  handleExcelUpload: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  hoverOnModal: PropTypes.bool.isRequired,
  handleCancelEvent: PropTypes.func.isRequired,
};

SpreadSheetUploader.defaultProps = {
  loading: false,
};

export default SpreadSheetUploader;
